const styles = () => ({
  snackbar: {
    marginTop: '20px',
  },
  // errorColor: {
  //   background: theme.palette.primary.darkErrorRed,
  // },
});

export default styles;
